import { render } from "./Loading.vue?vue&type=template&id=630b53d9&scoped=true"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=630b53d9&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/evyd/Stage/client-stage-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630b53d9"]])

export default __exports__